export default function sortObjLocaleBy(prop, lang) {
  return function (a, b) {
    const aa = a[prop];
    const bb = b[prop];

    return aa.localeCompare(bb, lang, { sensitivity: "base" });
  };
}
